//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    iconClass: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: 'empty-user-none',
    },
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
    btnTxt: {
      type: String,
      default: '',
    },
    theme: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    colorMode() {
      const theme = this.$store.state.user.colorMode || 'light';
      return this.theme ? `-${theme}` : '';
    },
  },
  methods: {
    btnClick() {
      this.$emit('emptyFunc');
    },
  },
};
